// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutPane_wrapper__hz09F"};